import Api from './api'

export default {
  baseUrl: 'Pricing',

  /**
   * getPremiumOptions
   *
   * @param {string} countryCode
   * @returns {Promise}
   */
  getPremiumOptions (countryCode = 'DE') {
    return Api.publicFetch(`${this.baseUrl}/InstancePremiumOption/${countryCode}`)
  },

  /**
   * getPricingModel
   *
   * @param {string} countryCode
   * @param {number} version
   * @returns {Promise}
   */
  getPricingModel (countryCode = 'DE', version = 1) {
    return Api.publicFetch(`${this.baseUrl}/PricingModel/${countryCode}/${version}`)
  },

  /**
   * getPricingStatus
   *
   * @param {number} instanceId
   * @returns {Promise}
   */
  getPricingStatus (instanceId) {
    return Api.baseFetch(`${this.baseUrl}/${instanceId}/Status`)
  },

  /**
   * saleTransaction
   *
   * @param {object} transaction
   * @param {string} transaction.instanceId
   * @param {string} transaction.termModelId
   * @param {number} transaction.pricingModelVersion
   * @param {string} transaction.type [instance, user, datev, backup, premium_support]
   * @param {number} transaction.users
   * @param {boolean} transaction.isCancel
   * @returns {Promise}
   */
  saleTransaction ({
    instanceId,
    termModelId,
    pricingModelVersion = 1,
    type,
    users,
    isCancel = false
  }) {
    return Api.baseFetch(`${this.baseUrl}/SaleTransaction`, {
      method: 'POST',
      body: JSON.stringify({
        type,
        instance_id: instanceId,
        number_of_users: users,
        is_cancellation: isCancel,
        term_model_id: termModelId,
        price_model_version: pricingModelVersion,
      }),
    })
  },
}
